function showProductSpinner() {
  const { spinner, viewedProductsCountContainer } = getPaginationAndFilterElements();

  spinner.classList.remove('hidden');
  viewedProductsCountContainer.classList.add('hidden');
}

function hideProductSpinner() {
  const { spinner, viewedProductsCountContainer } = getPaginationAndFilterElements();

  spinner.classList.add('hidden');
  viewedProductsCountContainer.classList.remove('hidden');
}

function watchFilterForm() {
  const { filterForm } = getPaginationAndFilterElements();

  if (filterForm) {
    filterForm.addEventListener('change', onFilterFormChange);
  }
}

function getQueryParamsString() {
  const { filterSizeOptionsChecked, filterProductTypeOptionsChecked, sortSelect } = getPaginationAndFilterElements();
  const filterSizeOptionsCheckedArray = Array.from(filterSizeOptionsChecked);
  const filterProductTypeOptionsCheckedArray = Array.from(filterProductTypeOptionsChecked);

  let queryParamsString = '';

  if (filterSizeOptionsCheckedArray.length > 0) {
    filterSizeOptionsCheckedArray.forEach((filterSizeOption) => {
      queryParamsString += `&filter.v.option.size=${filterSizeOption.value}`;
    });
  }

  if (filterProductTypeOptionsCheckedArray.length > 0) {
    filterProductTypeOptionsCheckedArray.forEach((filterProductTypeOption) => {
      queryParamsString += `&filter.p.product_type=${filterProductTypeOption.value}`;
    });
  }

  if (sortSelect) {
    queryParamsString += `&sort_by=${sortSelect.value}`;
  }

  return queryParamsString;
}

function updateProductCountText(productCountText) {
  const { productCountContainer } = getPaginationAndFilterElements();

  // remove all spaces
  productCountText = productCountText.replace(/\s/g, '');

  // add space between number and first letter
  productCountText = productCountText.replace(/(\d+)([a-zA-Z])/g, '$1 $2');

  if (productCountContainer) {
    productCountContainer.innerText = productCountText;
  }
}

function updateViewedProductsCountText(viewedProductsCountText) {
  const { viewedProductsCountContainer } = getPaginationAndFilterElements();

  if (viewedProductsCountContainer) {
    viewedProductsCountContainer.innerText = viewedProductsCountText;
  }
}

function updatePaginationPreviousPageUrl(paginationPreviousPageUrl) {
  const paginationAnchor = $('#btn-paginate-previous');

  if (paginationAnchor) {
    paginationAnchor.attr('href', paginationPreviousPageUrl);
  }
}

function updatePaginationNextPageUrl(paginationNextPageUrl) {
  const { paginateNextButton } = getPaginationAndFilterElements();

  if (paginateNextButton) {
    paginateNextButton.setAttribute('href', paginationNextPageUrl);
  }
}

function updatePaginationLoadMoreButton(hidden) {
  const { paginateLoadMoreButton } = getPaginationAndFilterElements();

  if (paginateLoadMoreButton) {
    if (hidden) {
      paginateLoadMoreButton.classList.add('hidden');
    } else {
      paginateLoadMoreButton.classList.remove('hidden');
    }
  }
}

function hideLoadMoreButton() {
  const { paginateLoadMoreButton } = getPaginationAndFilterElements();

  if (paginateLoadMoreButton) {
    paginateLoadMoreButton.classList.add('hidden');
  }
}

function handleLoadMoreButtonScroll() {
  const { paginateLoadMoreButton } = getPaginationAndFilterElements();

  if (paginateLoadMoreButton && !paginateLoadMoreButton.classList.contains('hidden')) {
    const domRect = paginateLoadMoreButton.getBoundingClientRect();
    const spaceBelow = window.innerHeight - domRect.bottom;
    const productColumnItemHeight = $('#products article')[0].getBoundingClientRect().height;
    const offsetMultiplier = window.innerWidth > 992 ? 2 : 3;
    const clickLoadMoreOffset = -Math.abs(productColumnItemHeight * offsetMultiplier);

    if (spaceBelow > clickLoadMoreOffset) {
      paginateLoadMoreButton.click();
    }
  }
}

function getProducts() {
  const {
    filterForm,
    filterFormSelector,
    resultsButton,
    resultsButtonSelector,
    productsContainer,
    productsInsertAnchor,
    productCountSelector,
    viewedProductsCountSelector,
    paginateNextButtonSelector,
    paginateLoadMoreButtonSelector,
  } = getPaginationAndFilterElements();
  let queryParamsString = getQueryParamsString();
  let requestUrl = '';

  if (queryParamsString) {
    requestUrl = `${window.location.pathname}?${queryParamsString}&filter.v.availability=1`;
  } else {
    requestUrl = window.location.pathname;
  }

  requestUrl = requestUrl.replace('?&', '?');

  showProductSpinner();

  // remove current products from page
  if (productsContainer) {
    productsContainer.remove();
  }

  // get filtered products
  $.ajax({
    url: requestUrl,
    type: 'GET',
    dataType: 'html',
  })
    .done(function (response) {
      const products = $(response).find('#products')[0];

      if (products) {
        setTimeout(() => {
          // add filtered products to page
          productsInsertAnchor.parentNode.insertBefore(products, productsInsertAnchor.nextSibling);

          // update product count text
          let productCountText = $(response).find(productCountSelector)[0].innerText;

          if (productCountText) {
            updateProductCountText(productCountText);
          }

          // update viewed products count text
          const viewedProductsCountText = $(response).find(viewedProductsCountSelector)[0].innerText;

          if (viewedProductsCountText) {
            updateViewedProductsCountText(viewedProductsCountText);
          }

          // update pagination next button
          const paginateNextButton = $(response).find(paginateNextButtonSelector)[0];

          if (paginateNextButton) {
            updatePaginationNextPageUrl(paginateNextButton.href);
          } else {
            hideLoadMoreButton();
          }

          // update pagination load more button
          const paginateLoadMoreButton = $(response).find(paginateLoadMoreButtonSelector)[0];

          if (paginateLoadMoreButton) {
            updatePaginationLoadMoreButton(false);
          } else {
            updatePaginationLoadMoreButton(true);
          }

          const responseFilterForm = $(response).find(filterFormSelector)[0];

          if (responseFilterForm) {
            filterForm.innerHTML = responseFilterForm.innerHTML;
            watchFilterForm();
          }

          const responseResultsButton = $(response).find(resultsButtonSelector)[0];

          if (responseResultsButton) {
            resultsButton.innerHTML = responseResultsButton.innerHTML;
          }

          // get color variants for products
          const productColumnItems = products.querySelectorAll('article');

          if (productColumnItems.length > 0) {
            getColorVariants(productColumnItems);
            initProductCardSwipers(productColumnItems);
          }

          // update url without reloading page
          window.history.pushState({}, document.title, requestUrl);

          hideProductSpinner();
        }, 300);
      }
    })
    .fail(function (response) {
      console.error('Unable to filter products');
      console.error(response);
    });
}

function loadMoreProducts() {
  const {
    paginateNextButton,
    productsSelector,
    productsContainer,
    viewedProductsCountSelector,
    paginateNextButtonSelector,
    paginateLoadMoreButtonSelector,
  } = getPaginationAndFilterElements();
  const nextPageUrl = paginateNextButton.href;

  showProductSpinner();

  $.ajax({
    url: nextPageUrl,
    type: 'GET',
    dataType: 'html',
  })
    .done(function (response) {
      const nextPageProducts = $(response).find(productsSelector)[0];

      if (nextPageProducts) {
        const products = nextPageProducts.querySelectorAll('article');

        // add new products to the bottom of the page
        if (products.length > 0) {
          products.forEach((productColumnItem) => {
            productsContainer.appendChild(productColumnItem);
          });

          getColorVariants(products);
          initProductCardSwipers(products);
        }

        // update viewed products count text
        const viewedProductsCountText = $(response).find(viewedProductsCountSelector)[0].innerText;

        if (viewedProductsCountText) {
          updateViewedProductsCountText(viewedProductsCountText);
        }

        // update pagination
        const paginateNextButton = $(response).find(paginateNextButtonSelector)[0];

        if (paginateNextButton) {
          updatePaginationNextPageUrl(paginateNextButton.href);
        } else {
          hideLoadMoreButton();
        }

        // update pagination load more button
        const paginateLoadMoreButton = $(response).find(paginateLoadMoreButtonSelector)[0];

        if (paginateLoadMoreButton) {
          updatePaginationLoadMoreButton(false);
        } else {
          updatePaginationLoadMoreButton(true);
        }

        // update url without reloading page
        window.history.pushState({}, document.title, nextPageUrl);
      }
    })
    .fail(function (response) {
      console.error('Unable to load more products');
      console.error(response);
    });

  hideProductSpinner();
}

function loadPreviousProducts() {
  const {
    paginatePreviousButton,
    productsSelector,
    productsContainer,
    paginatePreviousButtonSelector,
    paginatePreviousContainer,
  } = getPaginationAndFilterElements();
  const previousPageUrl = paginatePreviousButton.href;

  showProductSpinner();

  $.ajax({
    url: previousPageUrl,
    type: 'GET',
    dataType: 'html',
  }).done(function (response) {
    const previousPageProducts = $(response).find(productsSelector)[0];

    if (previousPageProducts) {
      let products = previousPageProducts.querySelectorAll('article');

      // add new products to the top of the page
      if (products.length > 0) {
        // reverse products array so they are added in the correct order
        products = Array.from(products).reverse();

        products.forEach((productColumnItem) => {
          productsContainer.prepend(productColumnItem);
        });

        getColorVariants(products);
        initProductCardSwipers(products);
      }

      // update pagination
      const paginateLoadPreviousButton = $(response).find(paginatePreviousButtonSelector)[0];

      if (paginateLoadPreviousButton) {
        const paginationPreviousPageUrl = paginateLoadPreviousButton.href;
        $(paginatePreviousContainer).removeClass('hidden');
        updatePaginationPreviousPageUrl(paginationPreviousPageUrl);
      } else {
        $(paginatePreviousContainer).addClass('hidden');
      }

      // update url without reloading page
      window.history.pushState({}, document.title, previousPageUrl);
    }
  });

  hideProductSpinner();
}

function getPaginationAndFilterElements() {
  return {
    spinnerSelector: '#product-list-spinner',
    spinner: $('#product-list-spinner')[0],
    filterSizeOptions: $('#collection-filters__form input[name="filter.v.option.size"]'),
    filterSizeOptionsChecked: $('#collection-filters__form input[name="filter.v.option.size"]:checked'),
    filterProductTypeOptions: $('#collection-filters__form input[name="filter.p.product_type"]'),
    filterProductTypeOptionsChecked: $('#collection-filters__form input[name="filter.p.product_type"]:checked'),
    filterFormSelector: '#collection-filters__form',
    filterForm: $('#collection-filters__form')[0],
    resultsButtonSelector: '#collection-filter__results-button',
    resultsButton: $('#collection-filter__results-button')[0],
    productsSelector: '#products',
    productsContainer: $('#products')[0],
    productsInsertAnchor: $('#product-insert-anchor')[0],
    productCountSelector: '.collection_item-count-wrapper',
    productCountContainer: $('.collection_item-count-wrapper')[0],
    viewedProductsCountSelector: '#amount-of-products-viewed',
    viewedProductsCountContainer: $('#amount-of-products-viewed')[0],
    paginatePreviousButtonSelector: '#btn-paginate-previous',
    paginatePreviousButton: $('#btn-paginate-previous')[0],
    paginateNextButtonSelector: '#btn-paginate-next',
    paginateNextButton: $('#btn-paginate-next')[0],
    paginateLoadPreviousButtonSelector: '#btn-load-previous',
    paginateLoadPreviousButton: $('#btn-load-previous')[0],
    paginateLoadMoreButtonSelector: '#btn-load-more',
    paginateLoadMoreButton: $('#btn-load-more')[0],
    paginatePreviousContainer: $('#pagination-previous-container')[0],
    paginateNextContainer: $('#pagination-next-container')[0],
    sortSelect: $('#collection__sort-select')[0],
    sortSelectSelector: '#collection__sort-select',
  };
}

// filters

function showFilterOffcanvas() {
  const filterOffcanvasSelector = '#filter-offcanvas';

  showOffcanvas(filterOffcanvasSelector);
}

function hideFilterOffcanvas() {
  const filterOffcanvasSelector = '#filter-offcanvas';

  hideOffcanvas(filterOffcanvasSelector);
}

// prevent scroll restoration

history.scrollRestoration = 'manual';

const onScrollCollection = throttle(() => {
  handleLoadMoreButtonScroll();
}, 500);

document.addEventListener('scroll', onScrollCollection);

// filter form

const onFilterFormChange = throttle(() => {
  getProducts();
}, 500);

$(document).ready(function () {
  watchFilterForm();
});

// color variants

function getColorVariants(productCardElementsArray) {
  if (!productCardElementsArray) {
    console.error('No products provided to getColorVariants function.');
    return;
  }

  if (productCardElementsArray instanceof NodeList || productCardElementsArray instanceof HTMLCollection) {
    productCardElementsArray = Array.from(productCardElementsArray);
  }

  const itemNumberArray = productCardElementsArray.map((el) => el.getAttribute('data-item-number')).filter(Boolean);

  const uniqueItemNumberArray = Array.from(new Set(itemNumberArray));

  const chunkSize = 6;
  const chunks = [];

  for (let i = 0; i < uniqueItemNumberArray.length; i += chunkSize) {
    chunks.push(uniqueItemNumberArray.slice(i, i + chunkSize));
  }

  // To store and merge all responses
  const allProductsHTML = [];

  function fetchChunk(index) {
    if (index >= chunks.length) {
      // All chunks processed
      const combinedHTML = document.createElement('div');
      combinedHTML.innerHTML = allProductsHTML.join('');

      const responseProducts = combinedHTML.querySelector('#products');

      if (responseProducts) {
        updateProductItemNumberImages(responseProducts);
        renderProductColorVariants();
      } else {
        console.warn('No #products found in combined response.');
      }

      return;
    }

    const tagQuery = chunks[index].map((tag) => `tag:"ItemNumber:${tag}"`).join(' OR ');
    const url = `/search?q=${encodeURIComponent(tagQuery)}&section_id=color-variant-search`;

    $.ajax({
      url,
      type: 'GET',
      dataType: 'html',
    })
      .done((response) => {
        allProductsHTML.push(response);
        fetchChunk(index + 1); // proceed to next chunk
      })
      .fail((error) => {
        console.error('Error fetching chunk of color variants:', error);
        fetchChunk(index + 1); // continue anyway
      });
  }

  // Start the first request
  fetchChunk(0);
}

function updateProductItemNumberImages(container) {
  if (!container) {
    return;
  }

  window.productItemNumberImages = window.productItemNumberImages || {};

  const products = container.querySelectorAll('[data-item-number]');

  products.forEach((el) => {
    const itemNumber = el.getAttribute('data-item-number');
    const imageUrl = el.getAttribute('data-featured-image');
    const productId = el.getAttribute('data-product-id');

    if (!itemNumber || !imageUrl || !productId) {
      return;
    }

    if (!window.productItemNumberImages[itemNumber]) {
      window.productItemNumberImages[itemNumber] = [];
    }

    window.productItemNumberImages[itemNumber].push({
      productId: productId,
      itemNumber: itemNumber,
      imageUrl: imageUrl,
    });
  });

  // Remove duplicate images for the same item number by product ID
  Object.keys(window.productItemNumberImages).forEach((itemNumber) => {
    const uniqueImages = {};
    window.productItemNumberImages[itemNumber] = window.productItemNumberImages[itemNumber].filter((variant) => {
      if (!uniqueImages[variant.productId]) {
        uniqueImages[variant.productId] = true;
        return true; // keep this variant
      }
      return false; // discard duplicate
    });
  });
}

function renderProductColorVariants() {
  const productColorVariantImagesLimit = 3;
  const excludeSelf = true;
  const productColorVariantListSelector = '.product-card__colors-list';
  const productColorVariantListItemSelector = '.product-card__colors-list-item';
  const productColorVariantListItemMoreSelector = '.product-card__colors-list-item--more';
  const productColorVariantListItemMoreTextSelector = '.product-card__colors-more-text';
  const productColorVariantImageClass = 'product-card__colors-image';

  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach((productCard) => {
    const itemNumber = productCard.getAttribute('data-item-number');
    const productId = productCard.getAttribute('data-product-id');

    if (!itemNumber || !productId) {
      return;
    }

    const variants = window.productItemNumberImages?.[itemNumber];

    if (!variants || variants.length === 0) {
      return;
    }

    const variantList = productCard.querySelector(productColorVariantListSelector);
    const moreItem = variantList?.querySelector(productColorVariantListItemMoreSelector);
    const moreText = variantList?.querySelector(productColorVariantListItemMoreTextSelector);

    if (!variantList || !moreItem || !moreText) {
      return;
    }

    // Remove all current items except the 'more' item
    const existingItems = variantList.querySelectorAll(
      `${productColorVariantListItemSelector}:not(${productColorVariantListItemMoreSelector})`,
    );
    existingItems.forEach((el) => {
      el.remove();
    });

    const filteredVariants = variants
      .filter((variant) => {
        return variant.productId !== productId;
      })
      .slice(0, productColorVariantImagesLimit);

    filteredVariants.forEach((variant) => {
      const listItem = document.createElement('li');
      listItem.classList.add('product-card__colors-list-item');

      const image = document.createElement('img');
      image.classList.add(productColorVariantImageClass);
      image.src = `${variant.imageUrl.replace(/&width=\d+/, '&width=64')}&height=64`.replace('crop=center', '');
      image.alt = `Color variant for item number ${variant.itemNumber}`;
      image.width = 64;
      image.height = 64;

      listItem.appendChild(image);
      variantList.insertBefore(listItem, moreItem);
    });

    const remaining = variants.length - filteredVariants.length - (excludeSelf ? 1 : 0);

    if (remaining > 0) {
      moreText.textContent = `+${remaining}`;
      moreItem.style.display = 'flex';
    } else {
      moreItem.style.display = 'none';
    }
  });
}

// Add to cart offcanvas

function showAddToCartOffcanvas(event, productHandle) {
  event.preventDefault();

  setAddToCartOffcanvasProductSizes(productHandle);
}

function hideAddToCartOffcanvas() {
  const addToCartOffcanvasSelector = '#add-to-cart-offcanvas';

  hideOffcanvas(addToCartOffcanvasSelector);

  destroyAddToCartOffcanvasSwiper();
}

function initAddToCartOffcanvasSwiper() {
  const swiper = new Swiper('.add-to-cart-offcanvas__swiper', {
    loop: true,
    pagination: {
      el: '.product__swiper-pagination',
      clickable: true,
    },
  });
}

function destroyAddToCartOffcanvasSwiper() {
  const swiperContainer = document.querySelector('.add-to-cart-offcanvas__swiper');

  if (swiperContainer) {
    swiperContainer.swiper.destroy(true, true);
  }
}

function setAddToCartOffcanvasProductSizes(productHandle) {
  fetch(`/products/${productHandle}?section_id=main-product`)
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionHtml = doc.querySelector('section.product');
      const sectionSizeHtml = doc.getElementsByClassName('add-to-cart__sizes-container')[0];
      const sizeOptions = sectionSizeHtml.querySelectorAll('.add-to-cart__size-option');
      const sizeOptionsContainer = document.getElementById('add-to-cart-offcanvas__product-sizes');

      if (sizeOptionsContainer && sizeOptions.length > 0) {
        sizeOptionsContainer.innerHTML = sectionSizeHtml.innerHTML;

        if (sizeOptions.length === 1) {
          sizeOptionsContainer.classList.add('hidden');
          const selectedSizeInput = sizeOptionsContainer.querySelector('input:checked');
          const variantId = selectedSizeInput ? selectedSizeInput.value : null;

          addCartItem(variantId, 1, false);

          return;
        }
      }

      const productDetailPageButton = document.getElementById('add-to-cart-offcanvas__view-product-button');

      if (productDetailPageButton) {
        productDetailPageButton.href = `/products/${productHandle}`;
      }

      const swiperContainer = document.querySelector('.add-to-cart-offcanvas__swiper');
      const productSwiper = sectionHtml.querySelector('.product__swiper');

      if (swiperContainer && productSwiper) {
        swiperContainer.innerHTML = productSwiper.innerHTML;

        const productSwiperImages = swiperContainer.querySelectorAll('.product__swiper-image');

        productSwiperImages.forEach((image) => {
          image.src = `${image.src}&height=384`;
        });

        initAddToCartOffcanvasSwiper();
      }

      const priceContainer = document.querySelector('.add-to-cart-offcanvas__price--regular');
      const priceCompareAtContainer = document.querySelector('.add-to-cart-offcanvas__price--compare-at');
      const priceSaleContainer = document.querySelector('.add-to-cart-offcanvas__price--sale');

      if (priceContainer && priceSaleContainer && priceCompareAtContainer) {
        const sectionRegularPrice = sectionHtml.querySelector('.product__price');
        const sectionCompareAtPrice = sectionHtml.querySelector('.product__compare-at-price');
        const sectionSalePrice = sectionHtml.querySelector('.product-card__price--sale');

        if (sectionRegularPrice) {
          priceContainer.innerHTML = sectionRegularPrice.innerHTML;
        } else {
          priceContainer.classList.add('hidden');
        }

        if (sectionCompareAtPrice) {
          priceCompareAtContainer.innerHTML = sectionCompareAtPrice.innerHTML;
          priceContainer.classList.add('hidden');
        } else {
          priceCompareAtContainer.classList.add('hidden');
        }

        if (sectionSalePrice) {
          priceSaleContainer.innerHTML = sectionSalePrice.innerHTML;
          priceContainer.classList.add('hidden');
        } else {
          priceSaleContainer.classList.add('hidden');
        }
      }

      const productTitle = document.getElementById('add-to-cart-offcanvas__product-title');

      if (productTitle) {
        const sectionTitle = sectionHtml.querySelector('.product__title');
        if (sectionTitle) {
          productTitle.innerHTML = sectionTitle.innerHTML;
        } else {
          productTitle.classList.add('hidden');
        }
      }

      const addToCartOffcanvasSelector = '#add-to-cart-offcanvas';
      const addToCartOffcanvas = $(addToCartOffcanvasSelector)[0];

      if (!addToCartOffcanvas) {
        console.error('Add to cart offcanvas not found');
        return;
      }

      showOffcanvas(addToCartOffcanvasSelector);
    });
}

function addToCartFromOffcanvas(event) {
  event.preventDefault();

  const selectedRadioVariant = document.querySelector('#add-to-cart-offcanvas__product-sizes input:checked');

  if (!selectedRadioVariant) {
    return;
  }

  const selectedVariantId = selectedRadioVariant.value;

  addCartItem(selectedVariantId, 1, false);
  hideAddToCartOffcanvas();
}

function initProductCardSwipers(productCardElementsArray) {
  if (!productCardElementsArray) {
    console.error('No product cards provided to initProductCardSwipers function.');
    return;
  }

  if (productCardElementsArray instanceof NodeList || productCardElementsArray instanceof HTMLCollection) {
    productCardElementsArray = Array.from(productCardElementsArray);
  }

  productCardElementsArray.forEach((productCard) => {
    const swiperContainer = productCard.querySelector('.product-card__swiper');

    if (swiperContainer && swiperContainer.hasAttribute('data-swiper-initialized')) {
      return;
    }

    swiperContainer.setAttribute('data-swiper-initialized', 'true');

    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 1,
        scrollbar: {
          el: '.product-card__swiper-scrollbar',
          hide: false,
        },
      });
    }
  });
}

// Events

$(document).ready(() => {
  // Initialize product item number images
  window.productItemNumberImages = {};

  // Get color variants for products on page load
  const products = document.querySelectorAll('#products article');
  if (products.length > 0) {
    getColorVariants(products);
    initProductCardSwipers(products);
  }
});
